import React from "react";
import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { Order } from "../pages/Alerts/AlertsUtils/alertsInterfaces";

export interface SortableHeadCell {
  id: string;
  label: string;
}

interface SortableTableHeadProps {
  headCells: readonly SortableHeadCell[];
  order: Order;
  orderBy: string;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  backgroundColor?: string;
  nonSortableCells?: { label: string }[];
}

export const SortableTableHead = (props: SortableTableHeadProps) => {
  const {
    headCells,
    order,
    orderBy,
    onRequestSort,
    backgroundColor,
    nonSortableCells = [],
  } = props;

  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  const tableHeadSx = backgroundColor
    ? {
        backgroundColor: `${backgroundColor} !important`,
        "& .MuiTableCell-head": {
          backgroundColor: `${backgroundColor} !important`,
          position: "sticky" as const,
          top: 0,
          zIndex: 1,
        },
      }
    : undefined;

  const cellSx = {
    fontFamily: "Mulish",
    fontWeight: "Bold",
    ...(backgroundColor && {
      backgroundColor: `${backgroundColor} !important`,
    }),
  };

  return (
    <TableHead sx={tableHeadSx}>
      <TableRow sx={backgroundColor ? { backgroundColor } : undefined}>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
            sx={cellSx}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {nonSortableCells.map((cell, index) => (
          <TableCell key={`non-sortable-${index}`} align="left" sx={cellSx}>
            {cell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
